import { ToastBold } from './'

type Props = {
	heading: string
}

// Redundant only being used in copyToAccountToast and the heading shows either Success or Failure
export default function ToastHeader({ heading }: Props): JSX.Element {
	return (
		<ToastBold>
			{heading} <br />
		</ToastBold>
	)
}
